import { AppSection, SortDirection } from '../constants';
import { Dashboard, DataObject, Language, Period } from '../models/core.models';
import { MassOperationResponse } from 'src/app/api/services/company-api.service';
// user-object.actions.ts
import { createAction, props } from '@ngrx/store';

import { MenuItem } from 'src/app/core/models/main-menu.models';

export const periodChanged = createAction(
  '[Core] Period Changed',
  props<{ period: Period }>(),
);

export const togglePeriodLocked = createAction(
  '[Core] Period Locked',
  props<{ isPeriodLocked: boolean; period: Period }>(),
);

export const togglePeriodLockedSuccess = createAction(
  '[Core] Period Locked Success',
  props<{ isPeriodLocked: boolean }>(),
);

export const applyDefaultPeriod = createAction('[Core] Apply Default Period');

export const selectPreviousPeriod = createAction(
  '[Core] Select Previous Period',
);

export const removePeriodFromHistory = createAction(
  '[Core] Remove Period From History',
  props<{ period: Period }>(),
);

/**
 * Triggered when user views a new object (feed, dashboard, workspace, etc.)
 */
export const objectChanged = createAction(
  '[Core] Object Changed',
  props<{ object: DataObject }>(),
);

export const toggleDarkMode = createAction('[Core] Toggle Dark Mode');

export const updateDashboardSuccess = createAction(
  '[Core] Update Dashboard Success',
  props<{ dashboard: Dashboard }>(),
);

export const massObjectOperationSuccess = createAction(
  '[Core] Mass Object Operation Success',
  props<{ response: MassOperationResponse }>(),
);

export const moveObjectsSuccess = createAction(
  '[Workspace] Move Objects Success',
  props<{ objects: MassOperationResponse }>(),
);

export const showShadow = createAction('[Core] Show Shadow');
export const hideShadow = createAction('[Core] Hide Shadow');

export const setAppSection = createAction(
  '[Core] Set App Section',
  props<{ appSection: AppSection; menuItems: Array<MenuItem> }>(),
);

export const switchActiveModule = createAction(
  '[Core] Switch Active Module',
  props<{ moduleId: number }>(),
);

export const setCoreLanguage = createAction(
  '[Core] Set Core Language',
  props<{ language: Language }>(),
);

export const setCoreLanguageSuccess = createAction(
  '[Core] Set Core Language Success',
);

export const switchPopupTab = createAction(
  '[Core] Switch Popup Tab',
  props<{ componentName: string }>(),
);

export const setCoreFilteredObjectsSortingField = createAction(
  '[CoreFilteredObjects] Set Sorting Field',
  props<{ sortingField: string }>(),
);

export const setCoreFilteredObjectsSortingDirection = createAction(
  '[CoreFilteredObjects] Set Sorting Direction',
  props<{ sortingDirection: SortDirection }>(),
);
